<template>
  <div>
    <v-card class="my-5 py-3 px-3" :loading="creatingExport">
      <v-card-title>
        {{ $t('export.create_export_for_box') }}: {{ this.exportBox.name }}
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field outlined
            :label="$t('export_create.export_name_file')"
            v-model="exportName" :counter="64" :rules="filenameRules">
          </v-text-field>
          <v-checkbox :label="$t('export_create.encrypt_export')" v-model="encryptExport">
          </v-checkbox>
          <v-text-field :type="'password'" v-if="encryptExport" v-model="password"
            outlined :label="$t('export_create.password')">
          </v-text-field>
          <v-text-field :type="'password'" v-if="encryptExport" v-model="passwordConfirm" :rules="[matchingPasswords]"
            outlined :label="$t('export_create.confirm_password')">
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn @click="navigateBack()" class="my-3" outlined>
          {{ $t('export_create.back') }}
        </v-btn>
        <v-btn @click="createExport()" color="primary" class="mx-3 my-3">
          {{ $t('export_create.export_action') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <export-progress :show-dialog="showExportStatusDialog" :export-identifier="createExportIdentifier">
    </export-progress>
    <v-snackbar color="error" v-model="showCreateExportError">
      {{ $t('export_create.create_error') }}
    </v-snackbar>
  </div>
</template>

<script>
import ExportProgress from '@/components/exports/ExportProgress'
import ExportService from '@/services/export/ExportService'

import i18n from '@/plugins/i18n'

export default {
  components: { ExportProgress },
  name: 'ExportCreate',
  data: () => ({
    exportBox: {
      id: 0,
      name: ''
    },
    encryptExport: false,
    exportName: '',
    password: '',
    passwordConfirm: '',
    showExportStatusDialog: false,
    createExportIdentifier: '',
    creatingExport: false,
    showCreateExportError: false,
    filenameRules: [
      v => !!v || i18n.t('export_create.name_required'),
      v => /^[ěščřžýáíéňťůúěďóĚŠČŘŽÝÁÍÉŇŤŮÚĚĎÓ-\w^&'@{}[\],$=!#().%+~ ]+$/.test(v) || i18n.t('export_create.filename_invalid')
    ]
  }),
  methods: {
    matchingPasswords () {
      if (this.password === this.passwordConfirm) {
        return true
      } else {
        return i18n.t('export_create.password_no_match')
      }
    },
    navigateBack () {
      this.$router.push({ name: 'ExportBoxContent', params: { exportBox: this.exportBox } })
    },
    createExport () {
      if (!this.$refs.form.validate()) {
        return
      }
      if (this.creatingExport) {
        return
      }
      this.creatingExport = true
      ExportService.createExport(this.exportBox.id, this.exportName, this.password, false).then(response => {
        this.createExportIdentifier = response.data
        this.showExportStatusDialog = true
        this.creatingExport = false
      }, _ => {
        this.creatingExport = false
        this.showCreateExportError = true
      })
    }
  },
  mounted () {
    if (this.$route.params.exportBox == null) {
      this.$router.push('/Export/BoxList')
      return
    }
    this.exportBox = this.$route.params.exportBox
  }
}
</script>



// WEBPACK FOOTER //
// src/components/exports/ExportCreate.vue